
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/service-levels",
      function () {
        return require("private-next-pages/service-levels.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/service-levels"])
      });
    }
  